import { confirm, DataTable, type TanstackReactTable } from "@devhop/ui";
import { ChevronRightIcon, EditIcon, TrashIcon } from "lucide-react";
import { RowActions } from "@/shared/ui/RowActions";
import type { VehicleModelDTO } from "../api/client";

type VehicleModelsTableProps = {
  canManage: boolean;
  isLoading: boolean;
  data: VehicleModelDTO[];
  offset: number;
  limit: number;
  totalCount: number;
  onEdit: (row: VehicleModelDTO) => void;
  onDelete: (id: string) => Promise<void>;
  onManageTrims: (modelId: string) => void;
  onPaginationChange: (offset: number, limit: number) => void;
};

export function VehicleModelsTable({
  canManage,
  isLoading,
  data,
  offset,
  limit,
  totalCount,
  onEdit,
  onDelete,
  onManageTrims,
  onPaginationChange,
}: VehicleModelsTableProps) {
  const columns: TanstackReactTable.ColumnDef<VehicleModelDTO>[] = [
    {
      id: "order",
      header: "ລຳດັບ",
      cell: ({ row }) => offset + row.index + 1,
      size: 70,
    },
    {
      id: "name",
      header: "ຮຸ່ນ",
      cell: ({ row }) => (
        <span className="font-medium">{row.original.name}</span>
      ),
      size: 160,
    },
    {
      id: "actions",
      header: "",
      cell: ({ row }) => {
        if (!canManage) return null;
        const id = row.original.id;
        const actions = [
          {
            label: "ຈັດການ configurations",
            icon: <ChevronRightIcon className="size-4" />,
            onClick: () => onManageTrims(id),
          },
          {
            label: "ແກ້ໄຂ",
            icon: <EditIcon className="size-4" />,
            onClick: () => onEdit(row.original),
          },
          {
            label: "ລຶບ",
            variant: "destructive" as const,
            icon: <TrashIcon className="size-4" />,
            onClick: async () => {
              const ok = await confirm({
                title: "ລຶບຮຸ່ນລົດ",
                description:
                  "ຖ້າມີ configuration ອ້າງອີງຢູ່ ຈະລຶບບໍ່ໄດ້. ຕ້ອງການລຶບບໍ?",
                actionText: "ລຶບ",
                ActionProps: { variant: "destructive" },
              });
              if (ok) await onDelete(id);
            },
          },
        ];
        return <RowActions actions={actions} maxInline={3} />;
      },
      size: 180,
    },
  ];

  return (
    <DataTable<VehicleModelDTO, unknown>
      noDataMessage="ບໍ່ມີຮຸ່ນ — ເພີ່ມຮຸ່ນແລ້ວຈຶ່ງເພີ່ມ configuration ໄດ້"
      isLoading={isLoading}
      columns={columns}
      data={data}
      offset={offset}
      limit={limit}
      totalCount={totalCount}
      onPaginationChange={(p) => onPaginationChange(p.offset, p.limit)}
    />
  );
}
